

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { Box, KeyValue, Grid, Pill } from 'web-library';
import { useTranslation } from 'react-i18next';
import { ApplicationStatusInSummary } from "../../../../api/candidate/appeal/model"

const useStyles = makeStyles()((theme) =>
({
  container: {
    paddingBottom: theme.spacing(2),
    maxWidth: 960,
  },
  [theme.breakpoints.down('md')]: {
    statusPill: {
      marginTop: theme.spacing(1)
    }
  },
}));

const ApplicationStatus = ({ ...props }: ApplicationStatusInSummary) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <Grid container direction="row">
        <Grid md={6} sm={12}>
          <KeyValue
            id="applicationId"
            keyText={t('appeal->>AppealSummary.ApplicationStatus.ID')}
            valueText={props.applicationId}
          />
        </Grid>
        <Grid md={6} sm={12} xs={12}>
          <KeyValue
            id="applicationStatus"
            keyText={t('appeal->>AppealSummary.ApplicationStatus.Status')}
            valueText={
              <Grid className={classes.statusPill}>
                <Pill label={props.status} variant='positive' />
              </Grid>
            }
          />
        </Grid>
      </Grid>

    </Box>
  );
};

export default ApplicationStatus;
